import { Chip } from '@mui/material';

interface AdminStatusBadgeProps {
  status: string;
  colorMap?: Record<string, 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'>;
}

/**
 * AdminStatusBadge - Status indicator badge
 *
 * Features:
 * - Color-coded status display
 * - Customizable color mapping
 *
 * Default color map:
 * - active/operational -> success
 * - inactive/degraded -> warning
 * - banned/down/error -> error
 */
export default function AdminStatusBadge({
  status,
  colorMap,
}: AdminStatusBadgeProps) {
  const defaultColorMap: Record<string, 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'> = {
    active: 'success',
    inactive: 'warning',
    banned: 'error',
    operational: 'success',
    degraded: 'warning',
    down: 'error',
    pending: 'warning',
    approved: 'success',
    rejected: 'error',
    resolved: 'success',
    new: 'info',
    in_progress: 'warning',
  };

  const finalColorMap = colorMap || defaultColorMap;
  const color = finalColorMap[status.toLowerCase()] || 'default';

  return (
    <Chip
      label={status.charAt(0).toUpperCase() + status.slice(1)}
      color={color}
      size="small"
    />
  );
}
